export const MergedTagType = {
	Manager: 'Manager',
	Worker: 'Worker',
	Utility: 'Utility',
};
export type IMergedTagType = keyof typeof MergedTagType;
